(function() {
    'use strict';

    const classShow = 'introanimsquares__layout--show';

    /**
     * Set an IntersectionObserver to watch each element.
     * This just sets an "is visible" boolean which is used by the scroll events, one of which is assigned per element.
     */
    function observer() {
        const elements = document.querySelectorAll('.js-introanimsquares');

        const observerOptions = {
            rootMargin: '0px 0px 0px 0px',
            threshold: 0
        }

        var observerAnim = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio !== 0) {
                    entry.target.sfl_isVisible = true;
                } else {
                    entry.target.sfl_isVisible = false;
                }
            });
        }, observerOptions);

        //
        elements.forEach(function(elm) {
            // store the event listener on the element itself, so we've got a reference to it to remove it later.
            // pass in a reference to the elm itself too.
            elm.sfl_scrollListener = squareEventListener.bind(null, elm);
            window.addEventListener('scroll', elm.sfl_scrollListener);
            observerAnim.observe(elm);
        });
    }

    function squareEventListener(elm) {
        calc(elm);
    }

    /**
     * Check if sufficiently in view, if so add the class that makes the squares appear
     */
    function calc(elm) {
        if (elm.sfl_isVisible) {
            // work out all the stuff
            const rect = elm.getBoundingClientRect();

            if (rect.top < window.innerHeight / 2) {
                show(elm);
                window.removeEventListener('scroll', elm.sfl_scrollListener);
            }
        }
    }

    /**
     * Add the class that makes the squares appear
     */
    function show(elm) {
        elm.classList.add(classShow);
    }

    observer();
})();